import { Component, EventEmitter, Input, Output, AfterViewInit, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormioLoader, FormioCustomComponent, ResourceNameService } from 'dp-formio';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-proccess-requirments-wrapper',
    templateUrl: './proccess-requirments-wrapper.component.html',
    // styleUrls: ['./proccess-requirments-wrapper.component.scss']
    encapsulation: ViewEncapsulation.None,
    providers: [FormioLoader]
})
export class ProccessRequirmentsWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
    dir: 'rtl' | 'ltr';
    @Input() required: boolean;
    @Input() value: any = {};
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() viewOnly: boolean;
    @Input() data: any;
    @Input() customOptions: any;
    @Input() formioComponent: any;
    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }
    bootstrapClass = '';
    resource = '';
    query = '';
    requirments: any[] = [];

    constructor(private translateService: TranslateService,
        private resourceNameService: ResourceNameService,
        private formioLoader: FormioLoader) {
        this.changeDirection(this.translateService.currentLang);
        this.sub = this.translateService.onLangChange.subscribe(data => {
            this.changeDirection(data.lang);
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.customOptions) {
            if (this.customOptions.resource || this.customOptions.query) {
                this.query = this.formioComponent.interpolate(this.customOptions.query, { data: this.data });
                this.resource = this.formioComponent.interpolate(this.customOptions.resource, { data: this.data });
                this.getRequirmentsResources();
            }
            if (this.customOptions.bootstrapClass) {
                this.bootstrapClass = this.customOptions.bootstrapClass;
            }
        }
    }


    notifyValue() {
        const data = this.requirments.map(q => {
            return {
                _id: q._id,
                checked: q.checked
            }
        });

        if (this.required) {
            const checkedCount = data.reduce((a, b) => a + +b.checked, 0);
            if (checkedCount != this.requirments.length) {
                this.value = null;
                this.valueChange.emit(this.value);
                return;
            }
        }
        this.value = { requirments: data };
        this.valueChange.emit(this.value);
    }

    private changeDirection(lang) {
        this.dir = null;
        setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
    }
    private getRequirmentsResources() {
        this.formioLoader.loading = true;
        this.sub = this.resourceNameService.loadCustomByFilterdKey(this.resource, this.query || '')
            .subscribe(data => {
                this.requirments = data.map(q => {
                    const checked = this.value && this.value.requirments ? (this.value.requirments.find(r => r._id == q._id) || {}).checked || false : false;
                    return {
                        _id: q._id,
                        ...q.data,
                        value: this.translateService.instant(`forms.common.${q.data.value}`),
                        checked: checked
                    };
                }).sort(function (a, b) {
                    if (a.order < b.order) { return -1; }
                    else if (a.order > b.order) { return 1; }
                    else { return 0; }
                });
                console.log(this.requirments);
                this.formioLoader.loading = false;
            }, error => {
                this.formioLoader.loading = false;
            });
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

}
